import appConfig from "../../config";
export const countryLists = [
  { code: "US", label: "America" },
  { code: "JP", label: "Japan" },
  { code: "EU", label: "Europe" },
  { code: "CN", label: "China" },
  { code: "KR", label: "Korea" },
  { code: "SG", label: "Asia Pacific" },
];

export const modelNumber = window.omModelNumber;
export default {
  countryLists,
  modelNumber,
};
